const rankings = [
  {
    rank: 1,
    title: '咒术回战',
    desc: '涩谷事变篇人气爆棚',
    tag: '热度飙升',
    icon: 'ri-fire-fill',
    iconColor: 'text-primary-500',
  },
  {
    rank: 2,
    title: '海贼王',
    desc: '艾尔巴夫篇持续连载中',
    tag: '经典长青',
    icon: 'ri-anchor-line',
    iconColor: 'text-accent-500',
  },
  {
    rank: 3,
    title: '鬼灭之刃',
    desc: '无限城篇剧场版期待榜第一',
    tag: '万众期待',
    icon: 'ri-sword-line',
    iconColor: 'text-primary-500',
  },
  {
    rank: 4,
    title: '我推的孩子',
    desc: '舞台剧篇剧情讨论热度极高',
    tag: '话题中心',
    icon: 'ri-star-fill',
    iconColor: 'text-accent-500',
  },
  {
    rank: 5,
    title: '斗破苍穹',
    desc: '中州篇持续刷新国漫纪录',
    tag: '国漫第一',
    icon: 'ri-flag-2-fill',
    iconColor: 'text-secondary-500',
  },
  {
    rank: 6,
    title: '葬送的芙莉莲',
    desc: '第二季确认制作引发热议',
    tag: '口碑神作',
    icon: 'ri-magic-line',
    iconColor: 'text-accent-500',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热门排行</h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            根据近期更新热度与读者讨论量综合排序
          </p>
        </div>

        <div className="space-y-2">
          {rankings.map((item) => (
            <a
              key={item.rank}
              href="#ranking"
              className="flex items-center gap-4 bg-background-50 rounded-lg border border-background-200/60 p-4 hover:border-primary-200 transition-colors cursor-pointer"
            >
              <div className="flex-shrink-0 w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-md bg-background-100">
                {item.rank <= 3 ? (
                  <span className={`text-lg md:text-xl font-heading font-bold ${item.rank === 1 ? 'text-primary-500' : item.rank === 2 ? 'text-accent-500' : 'text-secondary-500'}`}>
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-lg md:text-xl font-heading font-bold text-foreground-400">{item.rank}</span>
                )}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-0.5">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">{item.title}</h3>
                  <span className="px-2 py-0.5 bg-background-100 text-foreground-500 text-xs rounded-full flex-shrink-0">{item.tag}</span>
                </div>
                <p className="text-xs text-foreground-500 truncate">{item.desc}</p>
              </div>

              <div className={`flex-shrink-0 w-8 h-8 flex items-center justify-center`}>
                <i className={`${item.icon} text-lg ${item.iconColor}`}></i>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}